export const LIST = "AGENT_TRANSACTION_LISTING";
export const DROPDOWN = "AGENT_TRANSACTION_DROPDOWN";
export const DETAILS = "AGENT_TRANSACTION_DETAILS";
